import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { Small } from 'foundations-components/transitional/components/Small';
import { PROPERTIES } from '../constants';
import { FormType } from '../types';
import UnavailableNonHubSpotData from '../UnavailableNonHubSpotData';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function SubmissionRateCell({
  crmObject,
  propertyName
}) {
  const propertyValue = getPropertyValue(crmObject, propertyName);
  const submissionRatePercentage = Number(propertyValue) || 0;
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  if (formType === FormType.CAPTURED) return /*#__PURE__*/_jsx(UnavailableNonHubSpotData, {});
  if (submissionRatePercentage > 100) return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'dashboard.table.unknownTooltip'
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboard.table.unknown'
        })
      })
    })
  });
  return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: submissionRatePercentage,
    precision: 2
  });
}
export const submissionRate = {
  width: 170,
  multiline: true,
  renderCell: props => /*#__PURE__*/_jsx(SubmissionRateCell, Object.assign({}, props))
};